import { type KeywordFlaggingDataSource } from '../../data/keyword-flagging.datasource'
import { type KeywordListModel } from '../models/keyword-list.model'

export class GetKeywordListInteractor {
  constructor(private readonly dataSource: KeywordFlaggingDataSource) {}

  async execute(id: string): Promise<KeywordListModel | undefined> {
    const entity = await this.dataSource.getById(id)
    if (!entity) return undefined
    return {
      id: entity.id,
      name: entity.name,
      keywords: [...entity.keywords],
      autoModeration: entity.auto_moderation,
      dateModified: new Date(entity.date_modified)
    }
  }
}
